module.exports = __webpack_public_path__ + "img/subject_banner14.74a4e74a.png";